import { request, Methods, BaseApiV2 } from "@newview/infrastructure";
import { BaseVue } from "@newview/base-web";
import { ApiOption } from "../types";
import filterTool from "../util/filterTool";

export class NmisApi extends BaseApiV2 {
    proxyName?: string = "";
    controllerName?: string = "";
    apiOption?: ApiOption;
    projectId: number = 0;
    childsysId: number = 0;
    devProd: string = "dev";

    public get ProxyName(): any {
        return this.proxyName;
    }

    public get ControllerName(): any {
        return this.controllerName;
    }

    constructor() {
        super();
    }

    /**
     * 批量保存数据
     * @param datas 
     * @returns 
     */
    public saves(datas: any[]) {
        return this.send(datas, "saves", Methods.POST, this.apiOption!.controllerName, this.getHeaders(this.apiOption!, this.projectId, this.childsysId, this.devProd));
    }

    /**
     * 批量保存树状数据
     * @param datas 
     * @returns 
     */
    public saveTree(datas: any[]) {
        return this.send(datas, "saveTree", Methods.POST, this.apiOption!.controllerName, this.getHeaders(this.apiOption!, this.projectId, this.childsysId, this.devProd));
    }

    /**
     * 删除数据
     * @param id 
     * @returns 
     */
    public delete(id: number) {
        return this.send({ id }, "delete", Methods.GET, this.apiOption!.controllerName, this.getHeaders(this.apiOption!, this.projectId, this.childsysId, this.devProd));
    }

    /**
     * 创建请求Api
     * @param apiOption 
     * @param projectId 
     * @param childsysId 
     * @param devProd 
     * @returns 
     */
    static create(apiOption: ApiOption, projectId: number = 0, childsysId: number = 0, devProd: string = "dev") {
        const nmisApi: NmisApi = new NmisApi();

        nmisApi.proxyName = apiOption.proxyName;
        nmisApi.controllerName = apiOption.controllerName;
        nmisApi.apiOption = apiOption;
        nmisApi.projectId = projectId;
        nmisApi.childsysId = childsysId;
        nmisApi.devProd = devProd;
        // tableName: apiOption.tableName,
        // projectid: projectId, // 项目Id
        // childsysid: childsysId, // 子系统Id
        // devprod: devProd, // 开发环境
        nmisApi.addHeader("projectid", projectId);
        nmisApi.addHeader("childsysid", childsysId);
        nmisApi.addHeader("devprod", devProd);

        return nmisApi;
    }

    /**
     * 通过表名创建Api对象
     * @param tableName 表名
     * @param projectId 项目Id
     * @param childsysId 子系统Id
     * @param devProd 环境参数
     * @returns 
     */
    static createApiByTableName(tableName: string, projectId: number = 0, childsysId: number = 0, devProd: string = "dev"): NmisApi {
        const nmisApi: NmisApi = new NmisApi();

        nmisApi.proxyName = "CalcPythonApi";
        nmisApi.controllerName = "currency";
        nmisApi.apiOption = { proxyName: "CalcPythonApi", controllerName: "currency", tableName: tableName };
        nmisApi.projectId = projectId;
        nmisApi.childsysId = childsysId;
        nmisApi.devProd = devProd;

        nmisApi.addHeader("tableName", tableName);
        nmisApi.addHeader("projectid", projectId);
        nmisApi.addHeader("childsysid", childsysId);
        nmisApi.addHeader("devprod", devProd);

        return nmisApi;
    }

    /**
     * 通过代理名称和控制器名称创建Api对象
     * @param proxyName 代理名称
     * @param controllerName 控制器名称
     * @param projectId 项目Id
     * @param childsysId 子系统Id
     * @param devProd 环境参数
     * @returns 
     */
    static createApiByProxyNameAndControllerName(proxyName: string, controllerName: string, projectId: number = 0, childsysId: number = 0, devProd: string = "dev"): NmisApi {
        const nmisApi: NmisApi = new NmisApi();

        nmisApi.proxyName = proxyName;
        nmisApi.controllerName = controllerName;
        nmisApi.apiOption = { proxyName, controllerName };
        nmisApi.projectId = projectId;
        nmisApi.childsysId = childsysId;
        nmisApi.devProd = devProd;

        nmisApi.addHeader("projectid", projectId);
        nmisApi.addHeader("childsysid", childsysId);
        nmisApi.addHeader("devprod", devProd);

        return nmisApi;
    }

    /**
     * 执行编程设计程序
     * @param programkey 程序Key
     * @param data 参数
     * @param projectId 项目Id
     * @param childsysId 子系统Id
     * @param devProd 环境参数
     * @returns 
     */
    static async runAction(programkey, data, projectId: number = 0, childsysId: number = 0, devProd: string = "dev") {
        const nmisApi: NmisApi = new NmisApi();
        return await nmisApi.runAction(programkey, data, projectId, childsysId, devProd);
    }

    /**
     * 判断是否能发送请求
     * @param apiOption 
     * @param openData 
     * @returns 
     */
    static canSendOn(apiOption: ApiOption, openData) {
        if (filterTool.isNull(apiOption)) {
            return false;
        }

        if (apiOption.sendOn == true) {
            return true;
        }

        return filterTool.autoFilterValue(apiOption.sendOn, openData) == true;
    }

    /**
     * 获取请求头
     * @param apiOption 
     */
    getHeaders(apiOption: ApiOption, projectId: number = 0, childsysId: number = 0, devProd: string = "dev") {
        if (apiOption.proxyName == 'CalcPythonApi' && apiOption.controllerName == 'currency' && apiOption.tableName != '') {
            return {
                headers: {
                    tableName: apiOption.tableName,
                    projectid: projectId, // 项目Id
                    childsysid: childsysId, // 子系统Id
                    devprod: devProd, // 开发环境
                }
            }
        }

        return {};
    }

    /**
     * 发送请求
     * @param apiOption 
     * @param data 
     * @param projectId 
     * @param childsysId 
     * @param devProd 
     * @returns 
     */
    static async send(apiOption: ApiOption, data, projectId: number = 0, childsysId: number = 0, devProd: string = "dev") {
        const nmisApi: NmisApi = new NmisApi();

        if (!filterTool.isNull(apiOption.programkey)) {
            return await nmisApi.runAction(apiOption.programkey!, data, projectId, childsysId, devProd);
        }

        const url = filterTool.isNull(apiOption.url) ? `/${apiOption.proxyName}/${apiOption.controllerName}/${apiOption.actionName}` : apiOption.url;
        return await nmisApi.sendUrl(url, data, apiOption.method!, nmisApi.getHeaders(apiOption, projectId, childsysId, devProd));
    }


}